<template>
  <CrmUserInformation />
</template>

<script>
import CrmUserInformation from '../../components/adminCrm/CrmUserInformation.vue'
export default {
  components: {
    CrmUserInformation,
  },
}
</script>
